export default function ShopLinksPanel({ artist }) {
  const links = [
    { label: "Printify", url: artist.store_printify_url },
    { label: "Etsy", url: artist.store_etsy_url },
    { label: "Shopify", url: artist.store_shopify_url },
    { label: "Gumroad", url: artist.store_gumroad_url },
  ].filter(l => l.url);

  return (
    <div className="border rounded p-4">
      <div className="font-semibold">Shop This Artist</div>
      <div className="opacity-70 text-sm mt-1">External stores connected by the artist.</div>

      <div className="mt-4 flex flex-wrap gap-2">
        {links.length ? links.map(l => (
          <a key={l.label} href={l.url} target="_blank" rel="noreferrer" className="border rounded px-3 py-2 text-sm">
            {l.label}
          </a>
        )) : (
          <div className="opacity-60 text-sm">No store links connected yet.</div>
        )}
      </div>
    </div>
  );
}
